export const initialState = {
    status: false,
    animateStatus: false,
    // 
    endpoint_URL: '',
    title: '',
    pd_name: '',
    point_redeem: 0,
    exp_date: '',
    btn_text: ''
}

export const rewardReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'UPDATE_STATUS_ALERT_REDEEM':
            if(action.status)
            {
                return {
                    ...state,
                    status: action.status,
                    endpoint_URL: action.rw_data.endpoint_URL,
                    title: action.rw_data.title,
                    pd_name: action.rw_data.pd_name,
                    point_redeem: action.rw_data.point_redeem,
                    exp_date: action.rw_data.exp_date,
                    btn_text: action.rw_data.btn_text
                }
            }
            else
            {
                return {
                    ...state,
                    status: action.status
                }
            }
        case 'UPDATE_STATUS_ANIMATE_ALERT_REDEEM': 
            return {
                ...state,
                animateStatus: action.animate_status
            }
        default:
            return state;
    }
}